import type { BindingId } from '../types';
import { createDefaultImageSettings } from '../../../elements/image/contracts';
import type {
    ElementDefinition,
    ElementInsertionPresetOption,
    ElementInsertionPresetProvider,
} from '../../../elements/types';
import { listSystemImageAssets, type SystemImageAsset } from './assets';

const SYSTEM_ASSETS_IMAGE_BINDING_ID = 'system_assets.image' as BindingId;
const SUPPORTED_ELEMENT_TYPE = 'image';

function createSystemAssetImageDefinition(asset: SystemImageAsset): ElementDefinition {
    return {
        type: 'image',
        settings: {
            ...createDefaultImageSettings(),
            binding: {
                bindingId: SYSTEM_ASSETS_IMAGE_BINDING_ID,
                arg: asset.key,
            },
            alt: asset.label,
            sizing: 'custom',
            fit: 'contain',
            width: '4cm',
            height: '1.25cm',
        },
    };
}

function createSystemAssetPresetOption(asset: SystemImageAsset): ElementInsertionPresetOption {
    return {
        key: `system_asset:image:${asset.key}`,
        label: asset.label,
        description: asset.description,
        sourceLabel: gettext('DATA_SERVICE_SYSTEM_ASSET_SOURCE_LABEL'),
        supportedSwarmTypes: null,
        isEnabled: true,
        createDefinition: () => createSystemAssetImageDefinition(asset),
    };
}

// Provided rather than derived from the catalog because each preset pins one asset key.
export const systemAssetsInsertionPresetProvider: ElementInsertionPresetProvider = {
    supports({ elementType }) {
        return elementType === SUPPORTED_ELEMENT_TYPE;
    },
    resolvePresets() {
        return Promise.resolve(listSystemImageAssets().map(createSystemAssetPresetOption));
    },
};
